import { resource, RequestConfig } from '../helper/resource';

/**
 * 查询协议列表
 */
export function agreeListUsingPOST(req: CaListParam | void, config?: RequestConfig): Promise<ApiResultCaAgreeList> {
  return resource.post('/CACertificate/agreeList', req, config);
}

/**
 * 批量签署协议
 */
export function agreementSignUsingPOST(req: CAsignDto | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/CACertificate/agreementSign', req, config);
}

/**
 * 查询协议内容
 */
export function getContentUsingPOST(
  req: CaInfoParam | void,
  config?: RequestConfig
): Promise<ApiResultCaAgreementContentDto> {
  return resource.post('/CACertificate/getContent', req, config);
}
